import { useEffect, useState } from "react"
import { createLogger } from '../utils/logger'

const logger = createLogger('marketing')

export default function TermsAndConditionsPage() {
  const [htmlContent, setHtmlContent] = useState("")
  const [isLoading, setIsLoading] = useState(true)
  const [loadError, setLoadError] = useState(false)

  useEffect(() => {
    fetch("/TermsAndConditions.html")
      .then((res) => {
        if (!res.ok) throw new Error("Failed to fetch")
        return res.text()
      })
      .then((html) => {
        setHtmlContent(html)
        setIsLoading(false)
      })
      .catch((err) => {
        logger.error('Failed to load terms and conditions page', {
          view: 'terms',
          action: 'load_static_html',
        }, err)
        setLoadError(true)
        setIsLoading(false)
      })
  }, [])

  return (
    <div className="min-h-[60vh] bg-white px-6 py-10 pb-20">
      <div className="mx-auto max-w-3xl">
        {isLoading && (
          <div className="flex items-center gap-3 text-sm text-neutral-500">
            <span
              className="inline-block h-5 w-5 animate-spin rounded-full border-2 border-neutral-200 border-t-neutral-800"
              aria-hidden
            />
            Loading terms and conditions…
          </div>
        )}
        {loadError && (
          <p className="text-sm text-red-800" role="alert">
            Could not load this page. Please try again later or contact support.
          </p>
        )}
        {!isLoading && !loadError && (
          <div className="legal-html-content" dangerouslySetInnerHTML={{ __html: htmlContent }} />
        )}
      </div>
    </div>
  )
}
